import { extractCreatedForUserIdFromRoute } from './template-client-context.util';

// Persists the client context across client -> product route navigation so
// template lookups can still send the correct created_for_user_id later.
export const templateClientContextClientIdStorageKey = 'templateClientContextClientId';

export function getStoredTemplateClientContextClientId(): string | null {
  try {
    const clientId = sessionStorage.getItem(templateClientContextClientIdStorageKey)?.trim();
    return clientId || null;
  } catch {
    return null;
  }
}

export function setStoredTemplateClientContextClientId(clientId: string | null | undefined): void {
  const normalizedClientId = typeof clientId === 'string' ? clientId.trim() : '';

  if (!normalizedClientId) {
    return;
  }

  try {
    sessionStorage.setItem(templateClientContextClientIdStorageKey, normalizedClientId);
  } catch {
    // Ignore storage issues and let caller fall back to route/user context.
  }
}

export function clearStoredTemplateClientContextClientId(): void {
  try {
    sessionStorage.removeItem(templateClientContextClientIdStorageKey);
  } catch {
    // Ignore storage issues during logout / cleanup.
  }
}

export function storeTemplateClientContextClientIdFromRoute(route: string | null | undefined): void {
  setStoredTemplateClientContextClientId(extractCreatedForUserIdFromRoute(route));
}
